var render = function render(){var _vm=this,_c=_vm._self._c;return _c('td',{staticClass:"vrm-table__nowrap"},[_c('vrm-avatar',{attrs:{"user":_vm.user,"admin-key":_vm.adminKey}}),_vm._v("\n    "+_vm._s(_vm.user.name)+"\n")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }